import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import Css from './PlaneDetails.scss';
import ListBox from '@components/ListBox/ListBox';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');

const planeDetails = props => {
  let stylesContainer = {};
  if (window.innerWidth < 992) {
    stylesContainer.minHeight = props.screenHeight + 'px';
  } else {
    stylesContainer.height = props.screenHeight + 'px';
  }

  let styles = {};
  let classNames = '';
  if (window.innerWidth < 992) {
    styles.minHeight = props.screenHeight + 'px';
    styles.backgroundImage = `url(${Clouds})`;
    styles.backgroundSize = '100% 100%';
    styles.backgroundPosition = 'center center';
    classNames = 'pt-6 pb-4';
  } else {
    styles.height = props.screenHeight + 'px';
    classNames =
      'abs-container d-flex align-items-center justify-content-center';
  }

  return (
    <div
      id={props.id}
      className={'panel d-flex align-items-center'}
      style={styles}
    >
      <img
        src={Clouds}
        alt={'Slider1'}
        className={'img-fluid d-none d-lg-block'}
      />
      <Container fluid={true} className={classNames} style={stylesContainer}>
        <Row className={'w-100'} style={{ height: '60%' }}>
          <Col md={{ offset: 1, size: 4 }}>
            <Row>
              <Col className={Css.header + ' lakes-medium'}>{props.header}</Col>
            </Row>
            <Row>
              <Col xs={12} md={{ offset: 1, size: 11 }}>
                <Row>
                  <ListBox
                    activeBox={props.activeBox}
                    id={'plane-overview'}
                    key={'plane-overview'}
                    title={'Overview'}
                    click={() => props.click('plane-overview')}
                  />
                  <ListBox
                    activeBox={props.activeBox}
                    id={'plane-performance'}
                    key={'plane-performance'}
                    title={'Performance'}
                    click={() => props.click('plane-performance')}
                  />
                </Row>
                <Row>
                  <ListBox
                    activeBox={props.activeBox}
                    id={'range-maps'}
                    key={'range-maps'}
                    title={
                      props.header === 'Phenom 100' ? 'Range Map' : 'Range Maps'
                    }
                    click={() => props.click('range-maps')}
                  />
                  <ListBox
                    activeBox={props.activeBox}
                    id={'configuration'}
                    key={'configuration'}
                    title={'Configuration'}
                    click={() => props.click('configuration')}
                  />
                </Row>
              </Col>
            </Row>
          </Col>
          <Col
            md={{ offset: 1, size: 5 }}
            className={'d-flex align-items-center'}
          >
            {props.activeBox === 'plane-overview' && (
              <React.Fragment>
                <table className={'table'} cellSpacing={10}>
                  <thead>
                    <tr>
                      <th className={'header-red'}>Category</th>
                      <th className={'header-grey'}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.overview.map((row, i) => {
                      return (
                        <tr key={i}>
                          <td>{row.title}</td>
                          <td
                            dangerouslySetInnerHTML={{ __html: row.content }}
                          />
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </React.Fragment>
            )}
            {props.activeBox === 'plane-performance' && (
              <div
                className={
                  'd-flex justify-content-center align-items-center h-100'
                }
              >
                <img
                  src={props.performance}
                  alt={'Performance'}
                  className={'img-fluid'}
                />
              </div>
            )}
            {props.activeBox === 'range-maps' && (
              <div
                className={`${
                  Css['range-maps']
                } d-flex justify-content-center align-items-center h-70`}
              >
                <div className={'px-1'}>
                  <img
                    src={props.rangeMap}
                    alt={'Range Map'}
                    className={'img-fluid'}
                    style={{ maxHeight: props.heightSm ? '300px' : '400px' }}
                  />
                </div>
                {props.header === 'Phenom 100' && (
                  <div className={Css['plane-table-description']}>
                    * RANGE MAP SHOWN IS FOR ILLUSTRATIVE PURPOSES ONLY. ALL
                    FLIGHTS ARE SUBJECT TO JETSUITE FLIGHT OPERATIONS.
                  </div>
                )}
                {props.header !== 'Phenom 100' && (
                  <div className={Css['plane-table-description']}>
                    * RANGE MAPS SHOWN ARE FOR ILLUSTRATIVE PURPOSES ONLY. ALL
                    FLIGHTS ARE SUBJECT TO JETSUITE FLIGHT OPERATIONS.
                  </div>
                )}
              </div>
            )}

            {props.activeBox === 'configuration' && (
              <div
                className={`${
                  Css['range-maps']
                } d-flex justify-content-center align-items-center h-70`}
              >
                <div className={'px-1'}>
                  <img
                    src={props.lopa}
                    alt={'Lopa'}
                    className={'img-fluid mx-auto d-block'}
                    style={{ marginTop: '1rem', maxHeight: '350px' }}
                  />
                </div>
                <div className={Css['plane-table-description']}>
                  * CONFIGURATION IS SHOWN FOR ILLUSTRATIVE PURPOSES ONLY.
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default planeDetails;



// WEBPACK FOOTER //
// ./src/components/OurAircraft/PlaneDetails/PlaneDetails.js